require("./App.marko.css");
"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    marko_component = {
    onCreate: async function () {
        this.state = {
            freepage: false,
            askSignin: false,
            redirectPage: false,
            themeMode: 'light',
            onboarding: false
        };
        GState.bind(this, [
            'theme',
            'skeleton',
            'tenant',
            'user',
            'showMenu',
            'alert'
        ]);
        if (!this.state.user || this.state.user.isVisitor || this.state.user.role == 'OWNER')
            this.state.freepage = true;
        this.adaptiveThemeMode();
        this.checkSubscription();
        const {name, color} = this.state.theme;
        await import(`~/views/${ name }/theme/${ color || 'default' }/light`);
        await import(`~/views/${ name }/theme/${ color || 'default' }/dark`);
    },
    onMount: function () {
        this.checkOnboarding();
    },
    adaptiveThemeMode: function () {
        if (!this.state.user || !this.state.user.settings.theme.mode || this.state.user.settings.theme.mode == 'auto') {
            const themeMedia = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)');
            if (!themeMedia)
                return;
            GState.set('theme', {
                ...this.state.theme,
                mode: themeMedia.matches ? 'dark' : 'light'
            });
            themeMedia.addEventListener('change', e => GState.set('theme', {
                ...this.state.theme,
                mode: e.matches ? 'dark' : 'light'
            }));
            return;
        }
        GState.set('theme', {
            ...this.state.theme,
            mode: this.state.user.settings.theme.mode
        });
    },
    onTransitionSuccess: function () {
        window.ALLOW_TRANSLATION_TRACK && GState.DCR.clear();
    },
    checkOnboarding: function () {
        if (!this.state.user || !this.state.user.accounttype)
            return;
        const accounttype = this.state.user.accounttype.toLowerCase();
        if (!this.state.tenant || !this.state.tenant.settings || !this.state.tenant.settings.onboarding || !this.state.tenant.settings.onboarding[accounttype])
            return;
        const {enabled, requiredFields} = this.state.tenant.settings.onboarding[accounttype];
        if (!enabled || !Array.isArray(requiredFields) || !requiredFields.length)
            return;
        if (!this.state.user.super || requiredFields.filter(each => {
                return !this.state.user.super[each];
            }).length)
            this.state.onboarding = this.state.tenant.settings.onboarding[accounttype];
    },
    saveOnboardingData: function (data) {
        this.state.showOnboarding = false;
        if (isEmpty(data))
            return;
        if (!this.state.user.super)
            GState.user.update({ super: data }, 'profile');
        else {
            const superProfile = {};
            Object.entries(data).map(([key, value]) => superProfile['super.' + key] = value);
            GState.user.update(superProfile, 'profile');
        }
        this.state.onboarding = false;
    },
    checkSubscription: function () {
        if (!this.state.user || !this.state.user.accounttype)
            return false;
        const accounttype = this.state.user.accounttype.toLowerCase();
        if (!this.state.tenant || !this.state.tenant.settings || !this.state.tenant.settings.pricing || !this.state.tenant.settings.pricing[accounttype])
            return;
        const {enabled} = this.state.tenant.settings.pricing[accounttype];
        if (!enabled)
            return;
        if (!this.state.user.subscription || this.state.user.subscription.duration.end <= Date.now())
            this.state.redirectPage = 'subscription';
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/App.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    router_template = require("marko-router5/src/components/router/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    router_tag = marko_loadTag(router_template),
    Menu_template = require("./components/Menu.marko"),
    Menu_tag = marko_loadTag(Menu_template),
    GlobalAlert_template = require("./components/GlobalAlert.marko"),
    GlobalAlert_tag = marko_loadTag(GlobalAlert_template),
    marko_assign = require("marko/dist/runtime/helpers/assign"),
    DialogModal_template = require("../components/DialogModal/index.marko"),
    DialogModal_tag = marko_loadTag(DialogModal_template),
    Aside_template = require("./components/Aside/index.marko"),
    Aside_tag = marko_loadTag(Aside_template),
    Row_template = require("../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    Toolbar_template = require("./components/Toolbar.marko"),
    Toolbar_tag = marko_loadTag(Toolbar_template),
    AskPermission_template = require("./components/AskPermission.marko"),
    AskPermission_tag = marko_loadTag(AskPermission_template),
    Extension_template = require("../components/Extension/index.marko"),
    Extension_tag = marko_loadTag(Extension_template),
    TranslateTrack_template = require("../components/TranslateTrack/index.marko"),
    TranslateTrack_tag = marko_loadTag(TranslateTrack_template),
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("9315b5"),
    marko_node0 = marko_createElement("div", {
        "data-toggle": "menu",
        "class": "body-overlay"
      }, "2", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs0 = {
        "class": "animated faster fadeIn"
      },
    marko_attrs1 = {
        style: "transition:.6s",
        "class": "col zindex-4 p-0 vh-100 overflow-hidden"
      },
    marko_attrs2 = {
        "class": "position-fixed top-0 w-100 zindex-5"
      };

require("boxicons/css/boxicons.min");

require("public/css/bootstrap");

require("public/css/bootstrap-extended");

require("public/css/bootstrap-datetimepicker.min");

require("public/css/animate");

require("public/css/colors");

require("public/css/components");

require("public/js/bootstrap.min");

require("public/js/bootstrap-datetimepicker.min");

require("public/css/style.helper");

require("public/css/style.custom");

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", {
      "class": marko_classValue("th--" + state.theme.mode),
      id: "root"
    }, "0", component, null, 1);

  if (state.freepage) {
    router_tag({
        routes: input.Routes,
        options: {
            defaultRoute: input.DefaultPage
          },
        noWrapper: true
      }, out, __component, "1", [
      [
        "transition-success",
        "onTransitionSuccess",
        false
      ]
    ]);
  } else {
    out.n(marko_node0, component);

    out.be("div", marko_attrs0, "3", component);

    if (state.skeleton.type !== "ADMIN") {
      Menu_tag({}, out, __component, "4");
    } else {
      GlobalAlert_tag({}, out, __component, "5");
    }

    Row_tag({
        class: marko_classValue([
          "Body theme-bg vh-100 m-0",
          " " + ((state.skeleton.type == "ADMIN") || (!state.showMenu) ? "full" : "")
        ]),
        renderBody: function(out) {
          out.be("div", marko_attrs1, "7", component);

          router_tag({
              routes: input.Routes,
              options: {
                  defaultRoute: state.redirectPage || input.DefaultPage
                },
              noWrapper: true
            }, out, __component, "8", [
            [
              "transition-success",
              "onTransitionSuccess",
              false
            ]
          ]);

          if (state.alert && (!isEmpty(state.alert))) {
            const { message, actions, ...rest } = state.alert

            DialogModal_tag(marko_assign({
                message: message,
                actions: actions
              }, rest), out, __component, "9", [
              [
                "dismiss",
                () => GState.global.alert( false ),
                false
              ]
            ]);
          }

          out.ee();

          Aside_tag({}, out, __component, "10");
        }
      }, out, __component, "6");

    Toolbar_tag({}, out, __component, "11");

    AskPermission_tag({}, out, __component, "12");

    out.ee();
  }

  if (state.onboarding) {
    out.be("div", marko_attrs2, "13", component);

    Extension_tag({
        name: "Onboarding",
        payload: {
            action: "showcase",
            reference: state.onboarding.reference
          }
      }, out, __component, "14", [
      [
        "output",
        "saveOnboardingData",
        false
      ]
    ]);

    out.ee();
  }

  if (window.ALLOW_TRANSLATION_TRACK) {
    TranslateTrack_tag({}, out, __component, "15");
  }

  out.ee();
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
